import React from "react";
import BackgroundTitle from "../../components/ui/BackgroundTitle";
import Blogs from "../../components/ui/cards/Blog.js";

function Blog() {
  return (
    <>
      <div>
        <BackgroundTitle title='BLOG' />
      </div>
      <div className='px-5 sm:px-7 lg:px-14 xl:px-48 py-28'>
        <h1 className='uppercase text-center my-20 text-2xl sm:text-3xl text-gray-700'>
          RECENT FROM BLOG
        </h1>
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-8'>
          <Blogs
            date='August 12, 2023 Admin'
            title='New technology facilities'
            description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
            pic={require("../../assets/blog/1.jpg")}
          />
          <Blogs
            date='August 12, 2023 Admin'
            title='New technology facilities'
            description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
            pic={require("../../assets/blog/2.jpg")}
          />
          <Blogs
            date='August 12, 2023 Admin'
            title='New technology facilities'
            description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
            pic={require("../../assets/blog/3.jpg")}
            direction={true}
          />
          <Blogs
            date='August 12, 2023 Admin'
            title='New technology facilities'
            description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
            pic={require("../../assets/blog/4.jpg")}
            direction={true}
          />
          <Blogs
            date='August 12, 2023 Admin'
            title='New technology facilities'
            description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
            pic={require("../../assets/blog/5.jpg")}
          />
          <Blogs
            date='August 12, 2023 Admin'
            title='New technology facilities'
            description='A small river named Duden flows by their place and supplies it with
            the necessary regelialia.'
            pic={require("../../assets/blog/6.jpg")}
          />
        </div>
        <div className='flex justify-center items-center gap-1.5 text-primary mt-10'>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            {"<"}
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full bg-green-200'>
            1
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            2
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            3
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            4
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            5
          </p>
          <p className='px-3 py-1 hover:cursor-pointer border border-sky-200 rounded-full'>
            {">"}
          </p>
        </div>
      </div>
    </>
  );
}

export default Blog;
